import { render, staticRenderFns } from "./OfertaCA.vue?vue&type=template&id=1106fe70&scoped=true"
import script from "./OfertaCA.vue?vue&type=script&lang=js"
export * from "./OfertaCA.vue?vue&type=script&lang=js"
import style0 from "./OfertaCA.vue?vue&type=style&index=0&id=1106fe70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1106fe70",
  null
  
)

export default component.exports